import { Injectable } from '@angular/core';
import {map} from 'rxjs/operators';
import {ParticipantApiModel} from '../models/participant.api.model';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {plainToClass, plainToClassFromExist} from 'class-transformer';
import {ResultListApiModel} from '../models/result-list.api.model';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import {QueryParamsApiModel} from '../models/query-params-api.model';
import {QueryParamsService} from '../../core/services/query-params.service';

@Injectable({
  providedIn: 'root'
})
export class ParticipantRestService {
  private readonly resource: string = '/participants';

  constructor(
    private http: HttpClient,
    public params: QueryParamsService
  ) {
  }

  public create(participantAM: ParticipantApiModel, options?: {headers?: HttpHeaders}): Observable<ParticipantApiModel> {
    return this.http.post<ParticipantApiModel>(environment.apiUrl + this.resource, participantAM, options)
      .pipe(map((result: ParticipantApiModel) => plainToClass(ParticipantApiModel, result)));
  }

  public put(participantAM: ParticipantApiModel): Observable<ParticipantApiModel> {
    return this.http.put<ParticipantApiModel>(environment.apiUrl + participantAM['@id'], participantAM)
      .pipe(map((result: ParticipantApiModel) => plainToClass(ParticipantApiModel, result)));
  }

  public get(id: number): Observable<ParticipantApiModel> {
    return this.http.get<ParticipantApiModel>(environment.apiUrl + this.resource + '/' + id)
      .pipe(map((result: ParticipantApiModel) => plainToClass(ParticipantApiModel, result)));
  }

  public delete(participantAM: ParticipantApiModel, options?: {headers?: HttpHeaders}): Observable<HttpResponse<any>> {
    return this.http.delete<HttpResponse<any>>(environment.apiUrl + participantAM['@id'], options);
  }
  public getCollection(queryParamsApiModel: QueryParamsApiModel = new QueryParamsApiModel()): Observable<ResultListApiModel<ParticipantApiModel>> {
    const params = this.params.applyParameters(queryParamsApiModel);
    return this.http.get<ResultListApiModel<ParticipantApiModel>>(environment.apiUrl + this.resource, {params})
      .pipe(map(result => plainToClassFromExist(new ResultListApiModel<ParticipantApiModel>(ParticipantApiModel), result as object)));
  }
}
